import { Tabs } from 'antd';
import { RadarChartOutlined, DollarOutlined, SettingOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import CommandSystemCmp from "./CommandSystem";
import Financial from '../Financial';
import Operational from '../Operational';
import Compliance from '../Compliance';

const CommandSystem = () => {
  const items = [
    {
      key: 'radar',
      label: (
        <span>
          <RadarChartOutlined style={{ marginRight: '8px' }} />
          Radar+
        </span>
      ),
      children: <CommandSystemCmp />,
    },
    {
      key: 'financial',
      label: (
        <span>
          <DollarOutlined style={{ marginRight: '8px' }} />
          Financial
        </span>
      ),
      children: <Financial />,
    },
    {
      key: 'operations',
      label: (
        <span>
          <SettingOutlined style={{ marginRight: '8px' }} />
          Operations
        </span>
      ),
      children: <Operational />,
    },
    {
      key: 'compliance',
      label: (
        <span>
          <SafetyCertificateOutlined style={{ marginRight: '8px' }} />
          Compliance
        </span>
      ),
      children: <Compliance />,
    },
  ];

  return (
    <>
      <Tabs
        type="card"
        items={items}
        defaultActiveKey="radar"
        style={{ marginTop: '10px' }}
      />
    </>
  );
};

export default CommandSystem;